// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row-full-padding[data-v-0541a35e]{flex:1;min-width:0;padding:16px}.v3-video-wrapper[data-v-0541a35e]{display:flex;justify-content:center;align-items:center;width:100%}", ""]);
// Exports
module.exports = exports;
